var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"loading":_vm.loading,"items":_vm.items,"focus":_vm.fetch})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }